import { tv } from 'tailwind-variants'

export const closeButtonVariants = tv({
  base: 'flex items-center justify-center rounded-xl bg-glass-overlay-light shadow-white-top-accent transition-colors text-white/70 hover:text-white [&_svg]:transition-transform [&_svg]:duration-200 [&_svg]:ease-in-out hover:[&_svg]:rotate-90',
  variants: {
    size: {
      sm: 'w-6 h-6 p-1',
      md: 'w-8 h-8 p-1.5',
      lg: 'w-10 h-10 p-2'
    },
    variant: {
      default: '',
      ghost: 'bg-transparent shadow-none hover:bg-white/10'
    }
  },
  defaultVariants: {
    size: 'md',
    variant: 'default'
  }
})